module.exports = __webpack_public_path__ + "img/CellCycle-NPC_GSE200310.fabd43ef.png";